var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('section',{staticClass:"category-page"},[_c('Header'),_c('get-quote',{staticClass:"mt-2",attrs:{"quoteCard":_vm.quoteCard}}),_c('info-content'),_c('Questions'),_c('customer-comments')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }